import type { MouseEventHandler } from 'react';

import type { KcContext } from 'keycloakify/login/KcContext';

import { Icons } from 'src/shared/components/services/services.js';

import { cnSocialButtons } from './social-buttons.constants.js';

import './social-buttons.css';

const ALLOWED_PROVIDERS = ['google'];

export interface SocialButtonsProps {
    social?: KcContext.Login['social'];
    buttonTitle: string;
    onSocialClick?: MouseEventHandler<HTMLAnchorElement>;
}

export const SocialButtons = ({ social, buttonTitle, onSocialClick }: SocialButtonsProps) => {
    const providers = (social?.providers || [])
        .filter(({ alias }) => ALLOWED_PROVIDERS.includes(alias))
        .sort((a, b) => ALLOWED_PROVIDERS.indexOf(a.alias) - ALLOWED_PROVIDERS.indexOf(b.alias));

    if (providers.length === 0) {
        return null;
    }

    return (
        <div className={cnSocialButtons()}>
            {providers.map((p) => {
                const Icon = Icons[p.alias];

                const handleClick: MouseEventHandler<HTMLAnchorElement> = (event) => {
                    if (onSocialClick) onSocialClick(event);
                };

                return (
                    <a key={p.providerId} href={p.loginUrl} className={cnSocialButtons('item')} onClick={handleClick}>
                        <div className={cnSocialButtons('item-wrapper')}>
                            {Icon && <Icon className={cnSocialButtons('item-icon')} />}
                            <span className={cnSocialButtons('item-text')}>{`${buttonTitle} ${p.displayName}`}</span>
                        </div>
                    </a>
                );
            })}
        </div>
    );
};
